import React from 'react';
import glamorous from 'glamorous';

import { TaraSurvey } from '../features/Tara';

import StickersheetRow from './StickersheetRow';

const survey = {
  surveyId: 0,
  siteId: 0,
  questionList: [
    {
      questionText: "What was your favorite subject in school?",
      questionId: 5,
      sortOrder: 1,
      answerList: [
        {
          answerText: "Math",
          answerId: 7,
          sortOrder: 3
        },
        {
          answerText: "Reading",
          answerId: 8,
          sortOrder: 5
        },
        {
          answerText: "Art",
          answerId: 9,
          sortOrder: 8
        },
      ],
    },
    {
      questionText: "Which store do you feel most comfortable in?",
      questionId: 1,
      sortOrder: 3,
      answerList: [
        {
          answerText: "Nordstrom",
          answerId: 3,
          sortOrder: 2
        },
        {
          answerText: "Walmart",
          answerId: 1,
          sortOrder: 5
        },
        {
          answerText: "Target",
          answerId: 2,
          sortOrder: 9
        },
      ],
    },
    {
      questionText: "What snack would you choose right now?",
      questionId: 6,
      sortOrder: 6,
      answerList: [
        {
          answerText: "Chocolate",
          answerId: 10,
          sortOrder: 0
        },
        {
          answerText: "Granola",
          answerId: 13,
          sortOrder: 0
        },
        {
          answerText: "Potato Chips",
          answerId: 11,
          sortOrder: 6
        },
      ],
    },
    {
      questionText: "Which car brand do you identify with most?",
      questionId: 4,
      sortOrder: 9,
      answerList: [
        {
          answerText: "Mercedes",
          answerId: 6,
          sortOrder: 0
        },
        {
          answerText: "Ford",
          answerId: 4,
          sortOrder: 6
        },
        {
          answerText: "Honda",
          answerId: 5,
          sortOrder: 7
        },
      ],
    },
  ],
};

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
});

export default () => (
  <StickersheetRow title="Surveys">
    <Row>
      <TaraSurvey
        survey={survey}
        isOpen
        isAnimated
      />
    </Row>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/Surveys.js